import { paymentService } from "./api/services/paymentService";
import localforage from "localforage";
import { STORAGE_KEYS } from "./constants/storage";
import { log, logError } from "./utils/logger.js";

/**
 * Gets payment UUID from localForage or API if not found
 * @returns {Promise<string>} Payment UUID
 */
export async function getUUID() {
  try {
    let uuid = await localforage.getItem(STORAGE_KEYS.PAYMENT_UUID);
    log(uuid);
    if (!uuid) {
      uuid = await paymentService.getPaymentUUID();
      await localforage.setItem(STORAGE_KEYS.PAYMENT_UUID, uuid);
    }

    return uuid;
  } catch (error) {
    console.error("Error in getUUID:", error);
    throw error;
  }
}

/**
 * Checks payment status using UUID from localForage
 * If UUID is not found, requests a new one
 * @returns {Promise<Object>} Payment status
 */
export async function checkUUID(debug = false) {
  if (debug === true) {
    return "paid";
  }

  try {
    let uuid = await localforage.getItem(STORAGE_KEYS.PAYMENT_UUID);

    if (!uuid) {
      uuid = await getUUID();
    }

    const status = await paymentService.checkPaymentStatus(uuid);
    log(status);
    return status.status;
  } catch (error) {
    logError("Error in checkUUID:", error);
    throw error;
  }
}

/**
 * Redirects to payment page with UUID
 * If UUID is not found, requests a new one before redirect
 * @returns {Promise<void>}
 */
export async function pay() {
  try {
    const uuid = await getUUID();
    window.location.href = `/payments/payment/${uuid}`;
  } catch (error) {
    console.error("Error in pay:", error);
    throw error;
  }
}
